import React, { useState, useEffect, useMemo, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { getPageViews } from "../../api/WebpageDashboardApi";
import ContactLoader from "views/ContantLoader";
import { Container } from "reactstrap";
import Table from "../../views/Table";
import { useSelector, useDispatch } from "react-redux";
import { setCompanyUserLoading } from "ReduxStore/Slices/companyUserSlice";
import { toast } from "react-toastify";

var offSet = 0;
var matchNextButton = 1;
const PageViewsList = (props) => {
  const [dataApi, setDataApi] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [noOfDays, setnoOfDays] = useState(7);
  const [Vcount, setVcount] = useState(0);
  const { role , companyType } = useSelector(state => state.userSetter)


  const { companyUserLoading } = useSelector(
    (state) => state.companyUserSetter
  );
  const dispatch = useDispatch();
  useEffect(() => {
    setVcount(props.location.state.count);
    dispatch(setCompanyUserLoading(true));
  }, []);

  const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
    const startRow = pageSize * pageIndex;
    const endRow = startRow + pageSize;
    setPageIndex(pageIndex);


    setnoOfDays(props.location.state.noOfDays);
    //setPageIndex(pageIndex);
    setVcount(props.location.state.count);
    setTotal(props.location.state.count);

    let obj = {
      "noOfDays": props.location.state.noOfDays,
      "webpageUrl": props.location.state.webpageUrl

    }

    setPageCount(Math.ceil(props.location.state.count / pageSize));


    getPageViews(obj, pageSize, startRow).then((temp) => {
      let data = [];
      let count = 0;

      temp.forEach((t) => {
        let item = {
          personId: t.person && t.person.length ? t.person[0]._id : '',
          email: t.person && t.person.length ? t.person[0].email : "",
          firstName: t.person && t.person.length ? t.person[0].firstName : "",
          lastName: t.person && t.person.length ? t.person[0].lastName : "",
          time: t.createdAt,
          ip: t.eventData && t.eventData.ipAddress ? t.eventData.ipAddress : "",
          referrer: t.eventData && t.eventData.referrer ? t.eventData.referrer : "",
          zipCode : t.zipcode ? t.zipcode: '',
          city : t.city  ? t.city: '',
          country : t.country ? t.country: '',
          region : t.region ? t.region: '',
          matchStatus: t.matchStatus,
          amount: t.leadGenRevenue?'$'+Number.parseFloat(t.leadGenRevenue).toFixed(2):"",
          date: t.createdAt,
          comment: t.comment,

        }
        data.push(item);
        count++;

      });
      //setTotal(count);
      setDataApi(data);
      dispatch(setCompanyUserLoading(false));
      // setPageCount(Math.ceil(data.length / pageSize));
    });
  }, []);

  const data = useMemo(() => dataApi, [dataApi]);
  const columns = useMemo(
    () =>role== 'publisher'?  [
      {

        Header: "Email",
        accessor: "email",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },


      {

        Header: "Last Name",
        accessor: "lastName",
      },

      {

        Header: "Zip Code",
        accessor: "zipCode",
      },

      {

        Header: "City",
        accessor: "city",
      },
      {

        Header: "Region",
        accessor: "region",
      },

      {

        Header: "Country",
        accessor: "country",
      },
      {
        Header: "Match Status",
        accessor: "matchStatus",
      },
      {
        Header: "Rev-share Amount",
        accessor: "amount",
      },
      {
        Header: "Date",
        accessor: "date",
      },
      {
        Header: "Comment",
        accessor: "comment",
      },
      {

        Header: "IP Address",
        accessor: "ip",
      },
      {

        Header: "Referer",
        accessor: "referrer",
      },
      {

        Header: "Time",
        accessor: "time",
      }
    ] : companyType=='lead'?[
      {

        Header: "Email",
        accessor: "email",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },


      {

        Header: "Last Name",
        accessor: "lastName",
      },

      {

        Header: "Zip Code",
        accessor: "zipCode",
      },

      {

        Header: "City",
        accessor: "city",
      },
      {

        Header: "Region",
        accessor: "region",
      },

      {

        Header: "Country",
        accessor: "country",
      },
      {
        Header: "Match Status",
        accessor: "matchStatus",
      },
      {
        Header: "Date",
        accessor: "date",
      },
      {
        Header: "Comment",
        accessor: "comment",
      },
      {

        Header: "IP Address",
        accessor: "ip",
      },
      {

        Header: "Referer",
        accessor: "referrer",
      },
      {

        Header: "Time",
        accessor: "time",
      },
    ]:[
      {

        Header: "Email",
        accessor: "email",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },


      {

        Header: "Last Name",
        accessor: "lastName",
      },

      {

        Header: "Zip Code",
        accessor: "zipCode",
      },

      {

        Header: "City",
        accessor: "city",
      },
      {

        Header: "Region",
        accessor: "region",
      },

      {

        Header: "Country",
        accessor: "country",
      },

      
      {

        Header: "IP Address",
        accessor: "ip",
      },
      {

        Header: "Referer",
        accessor: "referrer",
      },
      {

        Header: "Time",
        accessor: "time",
      },
    ],
    []
  );

  return (
    <Container>
      <div className="page_heading">
        <h2>Users List</h2>
        <button
          className="btn btn-sm"
          style={{ color: "#114169" }}
          onClick={() => props.history.push(`/admin/dashboard`)}
        >{`< Back`}</button>
        <p className="sm d-flex align-items-center">
          You have {total} users through {noOfDays} days.
          <span className="inline-label ml-auto">
            Page No. {pageIndex + 1} of {pageCount}
          </span>
        </p>
      </div>
      <div></div>
      {dataApi ? (
        <div id="pageviewTable" className="dataTableOuter">
          {<Table columns={columns}
            data={data}
            pageCount={pageCount}
            fetchData={fetchData}
            loading={companyUserLoading}
            onRowClick={(e, person) => {
              if (person.personId) {
                window.open(`/admin/contact/details?id=${person.personId}`, '_blank').focus();

              } else {
                toast.info("Unidentified Accounts can't be viewed");
              }
            }}
            
            >
              
              
              </Table>}
        </div>
      ) : (
        <ContactLoader />
      )}
    </Container>
  );
};

export default PageViewsList;
